module.exports = __webpack_public_path__ + "img/53-ABITO-DOLCETTO-U-COLORI-LINO-STAMPE-LINO4.c56f7df4.jpg";